const branding = {
  BRANDING_NAME: 'Network International',
  BRANDING_NAME_AR: 'نتورك إنترناشيونال',
  privacyPolicyURL: 'https://www.network.ae/en/contents/view/privacy-notice',
  termsAndConditionsURL: 'https://www.network.ae/en/contents/view/terms-condition',
  pricingTermsAndConditionsURL: 'https://www.network.ae/en/contents/view/terms-condition',
} as const;

export default branding;
